import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.split.js";
import "core-js/modules/es.string.replace.js";
import { ref } from "vue";
import { useRouter, useRoute } from "vue-router";
export default {
  name: "Footer",
  setup: function setup() {
    var router = useRouter();
    var route = useRoute();

    var jumpTo = function jumpTo(val) {
      if (route.path == '/aboutUs') {
        var hash = '#' + val; // console.log('hash:', hash)

        if (hash.indexOf('#') != -1) {
          nextTick(function () {
            var id = hash.split('#')[1];
            id = decodeURIComponent(id);
            var el = document.getElementById(id); // console.log('滚动到：', id, el)

            if (el) {
              // 平滑滚动
              setTimeout(function () {
                el.scrollIntoView({
                  behavior: 'smooth'
                });
              }, 0);
            }
          });
        }
      }

      router.replace({
        path: '/aboutUs',
        hash: "#".concat(val)
      }); // router.go(0)
      // window.location.reload()
    };

    var isShowDouYin = ref(false); //是否展示抖音二维码

    var isShowWeibo = ref(false); //是否展示微博二维码

    var isShowBzhan = ref(false); //是否展示B站二维码

    var weixinFlag = ref(false); //是否展示B站二维码
    //鼠标移入展示微信二维码

    function showQR(id) {
      if (id == "douyin") {
        isShowDouYin.value = true;
      } else if (id == "weibo") {
        isShowWeibo.value = true;
      } else {
        isShowBzhan.value = true;
      }
    }

    var showWeixin = function showWeixin() {
      weixinFlag.value = true;
    };

    var leaveWeixin = function leaveWeixin() {
      weixinFlag.value = false;
    }; //鼠标离开隐藏微信二维码


    function hiddenQR() {
      isShowDouYin.value = false;
      isShowWeibo.value = false;
      isShowBzhan.value = false;
    } //回到顶部


    function toTop() {
      window.scrollTo({
        top: 0,
        behavior: "smooth"
      });
    }

    var jumpLegalNotice = function jumpLegalNotice() {
      window.open('https://www.tenacia.com/en/legalNotice'); // window.open('https://webtest.tenacia.com/en/legalNotice')
    };

    return {
      isShowDouYin: isShowDouYin,
      isShowWeibo: isShowWeibo,
      isShowBzhan: isShowBzhan,
      weixinFlag: weixinFlag,
      showQR: showQR,
      hiddenQR: hiddenQR,
      toTop: toTop,
      jumpTo: jumpTo,
      jumpLegalNotice: jumpLegalNotice,
      showWeixin: showWeixin,
      leaveWeixin: leaveWeixin
    };
  }
};